import LetsGetStarted from '../images/LetsGetStartedImg.png';
import LetsGetStarted_Mobile from '../images/LetsGetStartedImg_Mobile.png';

export const getImage = (img) => {
    switch (img) {
        case 'lets-get-started':
            return LetsGetStarted;
        case 'lets-get-started-mobile':
            return LetsGetStarted_Mobile;
        default:
            return null;
    }
};